import { CreateRegistroFacturaParams, registroFacturas } from "@/erp/contabilidad/registro-facturas";
import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { AlertSeverityEnum, UseMutationsParams } from "@/shared/interfaces";
import { handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";


const { post} = erpApi()


export const useCreateRegistroFactura = ({
  navigate,
  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient()
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createRegistroFactura,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['crear-factura-compra'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      setAlert &&
        setAlert(true, 'Registro de Factura correctamente.', AlertSeverityEnum.success)
    },
    onError: error => {
      enableErrorRedirect && navigate && returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''))
      handleAxiosError(error, customMessageErrorAlert)
    },
    onSettled: () => {
      setIsGlobalLoading(false)
    }
  })

}
//axions
//_get
export const getRegistroFactura = () => {

}
//_post
export const createRegistroFactura = (data: CreateRegistroFacturaParams) => {

  return post<registroFacturas>(`${urlBackend}api/v1/crear-factura-desde-compra-body/`, data, true)
}
